import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { BookingEvent } from '@bookings/interfaces/booking-event';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
const ConfirmationModal = () =>
  import('@shared/components/modals/confirmation-modal/confirmation-modal.vue');
const StdForm = () => import('../../auto-form/std-form/std-form.vue');
const EntityDeleteModalProvider = () =>
  import('@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue');

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
library.add(faPlus);

@Component({
  name: 'bpc-document-list-group-input',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-std-form': StdForm,
    'bpc-entity-table': EntityTable,
    'bpc-field-wrapper': FieldWrapper,
    'bpc-confirmation-modal': ConfirmationModal,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class DocumentListGroupInput extends mixins(AbstractField, AbstractTable) {
  @Prop([String, Number, Boolean, Array]) readonly value:
    | string
    | number
    | boolean
    | number[]
    | any[];

  @Prop(Array) readonly filters: any[];
  @Prop({ type: String, default: 'table-input' })
  declare readonly displayConfigName: string;
  @Prop(String) readonly fieldForStorage: string;
  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;
  //@Prop(String) readonly formConfigName: string;

  get model(): string | number | boolean | number[] {
    return this.value;
  }
  set model(val: string | number | boolean | number[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  public entity: any = null;
  public entityName = 'document';
  public pluralEntityName = 'documents';
  public loader: boolean = true;

  public customRowActions = {
    edit: {
      activated: true,
      type: 'action',
      icon: 'edit',
      show: true,
      event: 'edit',
      text: 'edit',
      permissions: ['update'],
    },
    download: {
      activated: true,
      type: 'action',
      icon: 'download',
      show: true,
      event: 'download',
      text: 'download',
      permissions: ['download'],
    },
    softDelete: {
      activated: true,
      type: 'action',
      icon: 'trash',
      show: true,
      event: 'soft-delete',
      text: 'soft-delete',
      permissions: ['delete'],
    },
  };

  get rowActions() {
    return {
      ...this.defaultRowActions,
      ...this.customRowActions,
    };
  }

  mounted() {
    this.$root.$on('refreshContractDocumentList', event => {
      this.$refs.provider.getEntities();
    });
  }

  destroyed() {
    this.$root.$off('refreshContractDocumentList');
  }

  extendUpdateRowActions(entity: any) {
    if (entity?.actions?.softDelete) {
      entity.actions.softDelete.activated =
        this.config.data.activatedRowActions.indexOf('softDelete') > -1 ||
        this.config.data.activatedRowMoreActions.indexOf('softDelete') > -1;
      entity.actions.softDelete.show = true;
    }
    if (entity?.actions?.edit) {
      entity.actions.edit.activated =
        this.config.data.activatedRowActions.indexOf('edit') > -1 ||
        this.config.data.activatedRowMoreActions.indexOf('edit') > -1;
      entity.actions.edit.show = true;
    }
    if (entity?.actions?.download) {
      entity.actions.download.activated =
        this.config.data.activatedRowActions.indexOf('download') > -1 ||
        this.config.data.activatedRowMoreActions.indexOf('download') > -1;
      entity.actions.download.show = true;
    }
    return null;
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'download': {
        const urlToDocument = $event.item.item.documents.url;
        window.open(urlToDocument, '_blank');
        break;
      }
    }
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  // TODO: Determine if model has ID or not to consume api or create in localstorage.
  getMode(): string {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      return 'api';
    } else {
      return 'storage';
    }
  }
  updateModel(): void {
    this.model = this.$refs.provider ? this.$refs.provider.items : null;
  }

  finishLoader(): void {
    this.loader = false;
  }

  onFormSave() {
    this.loader = true;
    console.log('Saving');
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      this.$refs.stdForm.formModel[filter['filterField']] = filter['value'];
    }
    this.$refs.stdForm.saveEntity();
  }

  onNew() {
    this.entity = null;
    this.showForm = true;
    // this.$bvModal.show('modal-resource-form');
    this.showDrawerSection = true;
    this.disabledForm = false;
  }
}
